import hatsApi from '@/services/hatsApi'

export default {
  service (qCode, qTitle, c, strl, limit, p, t) {
    let queryCode = qCode || ''
    let queryTitle = qTitle || ''
    let pageSize = limit || ''
    let page = p || ''
    let type = t || ''
    let countryId = c || null
    let serviceTypeReservationLine = strl || null
    let pagination = ''

    let filter = [{
      property: 'queryTitle',
      value: queryTitle
    }, {
      property: 'queryCode',
      value: queryCode
    }]

    if (pageSize) {
      pagination += '&pageSize=' + pageSize
    }

    if (page) {
      pagination += '&page=' + page
    }

    if (t !== null) {
      filter.push({
        property: 'serviceTypeId',
        value: type
      })
    }

    if (countryId !== null) {
      filter.push({
        property: 'countryId',
        value: countryId
      })
    }

    if (serviceTypeReservationLine !== null) {
      filter.push({
        property: 'serviceTypeReservationLine',
        value: serviceTypeReservationLine
      })
    }

    return hatsApi().get('/master-data/service/?filter=' + JSON.stringify(filter) + pagination)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Search.js